import { WorkflowStep } from './workflowVisualizationModel';

export function getTooltipLabel(step: WorkflowStep) {
  let label = '';

  if (step.triggeredBy) {
    label += step.triggeredBy;
  }

  if (step.triggeredAt) {
    const triggeredAtDate = new Date(step.triggeredAt);
    const dateTimeFormat = new Intl.DateTimeFormat([...navigator.languages], {
      dateStyle: 'short',
      timeStyle: 'short',
    });

    if (label.length > 0) {
      label += '\n';
    }

    label += Number.isNaN(triggeredAtDate.valueOf())
      ? step.triggeredAt
      : dateTimeFormat.format(triggeredAtDate);
  }

  return label;
}
